// src/Components/Pages.jsx
import React, {useEffect, useState, useRef} from 'react';
import {Redirect} from 'react-router-dom';
import Modal from 'react-modal';
import BurgerModal from './Modals';
import {browserName, osName} from "react-device-detect";
import RegSkeleton from './Skeletons';
import {wait} from '@testing-library/user-event/dist/utils';
import MainLink from "./Link";

const api = `${MainLink()}api/`

const Register = () => {

    const api_reg_url = api + "register/questions"
    const api_reg_url_check_answer = api + "register/check-answer"
    const api_reg_url_put_acc = api + "register/create-acc"
    const api_reg_url_send_mail = api + "register/send-verify-code"
    const api_reg_url_submit_code = api + "register/submit-verify-code"
    const [data, setData] = useState(null); // Состояние для хранения данных
    const [loading, setLoading] = useState(true); // Состояние загрузки
    const [error, setError] = useState(null); // Состояние ошибки
    const [testError, setTestError] = useState(false); // Состояние ошибки
    const [questionNum, setQuestionNum] = useState(1);
    const [correctAnswers, setCorrectAnswers] = useState(1);
    const [stage, setStage] = useState(2);
    const [ip, setIp] = useState("");
    const [targetTimer, setTargetTimer] = useState(60)
    const [regError, setRegError] = useState(false)
    const openBurgerModalRef = useRef(null);
    const triggerBurgerModal = () => {
        if (openBurgerModalRef.current) {
            openBurgerModalRef.current(); 
        }
    };

    const [ucpName, setUcpName] = useState("");

    const handleChangeUcpName = (e) => {
        let inputValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
        if (inputValue.length <= 20) {
            setUcpName(inputValue); 
        }
    };

    const questionSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        try {
            const response = await fetch(api_reg_url_check_answer, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if (data === true) {
                    setCorrectAnswers(correctAnswers + 1)
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }

        setTestError(false)
        if (questionNum < 10) {
            setQuestionNum(questionNum + 1)
        } else {
            if (correctAnswers >= 7) {
                setStage(2)
            } else {
                setTestError(true)
                setQuestionNum(1);
                setCorrectAnswers(0);
            }
        }


    };


    const RegisterSubmit = async (event) => {
        event.preventDefault(); // - стандартное поведение отправки формы (редирект)

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            const response = await fetch(api_reg_url_put_acc, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if(data.status !== "OK"){
                    switch(data.message){
                        case "Wrong login or password":
                            setRegError("Неправильно введен логин или пароль!")
                            break;
                        case "This player already exists":
                            setRegError("Пользователь с такими данными уже существует!")
                            break;
                    }
                    
                }
                else{
                    localStorage.setItem('jwtToken', data.jwt);
                    localStorage.setItem('user-login', data.player.login)
                    localStorage.setItem('user-password', data.player.password)
                    localStorage.setItem('user-id', data.player.id)
                    localStorage.setItem('user-email', data.player.email)
                    try {
                        const response = await fetch(api_reg_url_send_mail, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({email: payload["email"]}),
                        });
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
                        }
                        if (response.ok) {
                            if (response.headers.get('Content-Length') === '0') {
                                throw new Error('Empty response body');
                            }
                            const data = await response.json();
                            if (data === true) {
                                setStage(3);
                            } else {
                                alert("Произошла непредвиденная ошибка. Попробуйте позже!")
                            }
            
            
                        } else {
                            const error = await response.json();
                            console.error('Ошибка:', error);
            
                        }
                    } catch (err) {
                        console.error('Ошибка соединения:', err);
                    }
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
        
    };


    const SubmitCode = async (event) => {

        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        try {
            const response = await fetch(api_reg_url_submit_code, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: payload["pincode-1"] + payload["pincode-2"] + payload["pincode-3"] + payload["pincode-4"] + payload["pincode-5"] + payload["pincode-6"],
                    email: localStorage.getItem("user-email")
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if (data === true) {
                    window.location.href = "../../../ucp/";
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }

    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(api_reg_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setData(result); 
            } catch (err) {
                setError(err.message); 
                fetchData()
            } finally {
                setLoading(false); 
            }
        };

        fetchData(); 

        const fetchIP = async () => {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                setIp(data.ip);
            } catch (error) {
                console.error("Ошибка при получении IP:", error);
            }
        };

        fetchIP();

    }, []); 
    if (loading) return <div className='App'>
        <div className='main-container' style={{minHeight: "100vh"}}>
            <RegSkeleton/>
        </div>
    </div>;
    if (error) return <p>Ошибка: {error}</p>;


    if (stage == 1) return (
        <div className="App">
            <div className="main-container">
                <div className='header'>
                    <button className='burger-button' onClick={triggerBurgerModal}>
                        <div></div>
                    </button>
                    <BurgerModal onTrigger={(openBurgerModal) => {
                        openBurgerModalRef.current = openBurgerModal;
                    }}/>
                </div>
                <div className='register-question-container'>
                    <div className='register-container'>

                        <span className='register-title'>РЕГИСТРАЦИЯ</span>
                        {testError && (<span className='auth-error-span'>Вы допустили более 3 ошибок! Пройдите тест заново.</span>)}
                        <span className='title-question-number'>Вопрос {questionNum}</span>

                        <span
                            className='title-question'>{JSON.stringify(data.questions[questionNum - 1][1]).slice(1, JSON.stringify(data.questions[questionNum - 1][1]).length - 1)}</span>
                        <form onSubmit={questionSubmit}>
                            <input type="hidden" name="question_id"
                                   value={JSON.stringify(data.questions[questionNum - 1][0])}/>
                            <div className='answers-container'>
                                <ul>
                                    <li>
                                        <input type='radio' id="answer-1" name="answer" value="1"
                                               defaultChecked></input>
                                        <label
                                            for="answer-1">{JSON.stringify(data.questions[questionNum - 1][2]).slice(1, JSON.stringify(data.questions[questionNum - 1][2]).length - 1)}</label>
                                        <div class="check"></div>
                                    </li>
                                    <li>
                                        <input type='radio' id="answer-2" name="answer" value="2"></input>
                                        <label
                                            for="answer-2">{JSON.stringify(data.questions[questionNum - 1][3]).slice(1, JSON.stringify(data.questions[questionNum - 1][3]).length - 1)}</label>
                                        <div class="check">
                                            <div class="inside"></div>
                                        </div>
                                    </li>
                                    <li>
                                        <input type='radio' id="answer-3" name="answer" value="3"></input>
                                        <label
                                            for="answer-3">{JSON.stringify(data.questions[questionNum - 1][4]).slice(1, JSON.stringify(data.questions[questionNum - 1][4]).length - 1)}</label>
                                        <div class="check">
                                            <div class="inside"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <button className='register-button-next' type="submit">СЛЕДУЮЩИЙ ВОПРОС</button>
                        </form>

                    </div>

                </div>
            </div>
        </div>

    )

    if (stage == 2) return (
        <div className="App">
            <div className="main-container">
                <div className='header'>
                    <button className='burger-button' onClick={triggerBurgerModal}>
                        <div></div>
                    </button>
                    <BurgerModal onTrigger={(openBurgerModal) => {
                        openBurgerModalRef.current = openBurgerModal;
                    }}/>
                </div>
                <div className='register-question-container'>
                    <div className='register-container'>
                        <span className='register-title'>РЕГИСТРАЦИЯ</span>
                        {regError !== false ? (<span className="auth-error-span">{regError}</span>) : false}
                        
                    
                        <form onSubmit={RegisterSubmit}>
                            <div>
                                <input className="register-input-form" placeholder="Имя аккаунта*" type="text" name="login"
                                       minLength={5} maxLength={20}
                                       onChange={handleChangeUcpName}
                                       value={ucpName}
                                />

                                <input className='register-input-form' placeholder='Email*' type='email' name="email"
                                       maxLength={36} minLength={6}></input>
                                <input className='register-input-form' placeholder='Пароль*' type='password'
                                       name="password" maxLength={24} minLength={7}></input>
                                <input className='register-input-form' placeholder='Подтверждение пароля*'
                                       type='password' name="re_password" maxLength={24} minLength={7}></input>
                                <input type='hidden' name="regIP" value={ip}></input>
                            </div>
                            <button className='register-button-next' type="submit">ЗАРЕГИСТРИРОВАТЬСЯ</button>
                        </form>

                    </div>

                </div>
            </div>
        </div>
    )
    if (stage == 3) {
        const handleInputChange = (e, index) => {
            const value = e.target.value;
            if (/^\d$/.test(value)) {
                const nextInput = document.getElementById(`pincode-${index + 1}`);
                if (nextInput) nextInput.focus();
            } else {
                e.target.value = "";
            }
        };

        const handleKeyDown = (e, index) => {
            if (e.key === "Backspace" && e.target.value === "") {
                const prevInput = document.getElementById(`pincode-${index - 1}`);
                if (prevInput) prevInput.focus();
            }
        };

        const timer = setTimeout(() => {
            if (targetTimer != 0) {
                setTargetTimer(targetTimer - 1)
            }
        }, 1000); // 3 секунды

        const handleResendMail = async () => {
            if (targetTimer > 0 || localStorage.getItem("user-email") === undefined || localStorage.getItem("user-email") === null) {
                return;
            }
            try {
                const response = await fetch(api_reg_url_send_mail, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({email: localStorage.getItem("user-email")}),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
                }
                if (response.ok) {
                    if (response.headers.get('Content-Length') === '0') {
                        throw new Error('Empty response body');
                    }
                    const data = await response.json();
                    if (data === true) {
                        setTargetTimer(60)
                    } else {
                        alert("Произошла непредвиденная ошибка. Попробуйте позже!")
                    }


                } else {
                    const error = await response.json();
                    console.error('Ошибка:', error);

                }
            } catch (err) {
                console.error('Ошибка соединения:', err);
            }
        }
        return (
            <div className="App">
                <div className="main-container">
                    <div className='header'>
                        <button className='burger-button' onClick={triggerBurgerModal}>
                            <div></div>
                        </button>
                        <BurgerModal onTrigger={(openBurgerModal) => {
                            openBurgerModalRef.current = openBurgerModal;
                        }}/>
                    </div>
                    <div className='register-question-container'>
                        <div className='register-container'>

                            <span className='register-title'>РЕГИСТРАЦИЯ</span>
                            <span>На электронную почту вам было выслано письмо подтверждения. Пожалуйста, введите код из письма в поля ниже.</span>
                            <form onSubmit={SubmitCode}>
                                <center>
                                    <div>
                                        {[...Array(6)].map((_, i) => (
                                            <input
                                                key={i}
                                                id={`pincode-${i + 1}`}
                                                className="code-input-number"
                                                maxLength={1}
                                                pattern="[\d]*"
                                                type="tel"
                                                name={`pincode-${i + 1}`}
                                                onChange={(e) => handleInputChange(e, i + 1)}
                                                onKeyDown={(e) => handleKeyDown(e, i + 1)}
                                            />
                                        ))}
                                    </div>
                                </center>
                                <span
                                    className='reg-span-timer'>{targetTimer > 0 ? "Вы сможете переотправить письмо через " + targetTimer + " секунд" : "Вы можете переотправить письмо."}</span>
                                <button type='button' className='ucp-simple-blur-button' style={{
                                    width: "97%",
                                    borderRadius: "15px",
                                    height: "45px",
                                    marginBottom: "0",
                                    fontSize: "16px"
                                }} onClick={handleResendMail}>ПЕРЕОТПРАВИТЬ ПИСЬМО
                                </button>
                                <button className='register-button-next' type="submit"
                                        style={{marginTop: "20px"}}>ЗАРЕГИСТРИРОВАТЬСЯ
                                </button>
                            </form>

                        </div>

                    </div>
                </div>
            </div>
        )
    }
}


const BuildPage = (index) => {
    const openBurgerModalRef = useRef(null);
    const triggerBurgerModal = () => {
        if (openBurgerModalRef.current) {
            openBurgerModalRef.current(); // Вызываем функцию открытия
        }
    };
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [showError, setShowError] = useState(false);
    const [gAuthNeeds, setGAuthNeeds] = useState(false);
    const [verifyAuthErr, setVerifyAuthErr] = useState("");

    const openLoginModal = () => {
        setModalIsOpen(true);
        setVisible(false)
    };

    const closeLoginModal = () => {
        setModalIsOpen(false);
        setVisible(true)
    };

    const handleShowError = () => {
        setShowError(true);
    };

    // Функция для скрытия ошибки
    const handleHideError = () => {
        setShowError(false);
    };


    const api_url = api + "users"


    const handleSubmit = async (event) => {
        event.preventDefault(); // - стандартное поведение отправки формы (редирект)

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();

                if (data.status == "error") {
                    handleShowError();
                } else if (data.status == "gauth"){
                    setGAuthNeeds(true)
                    localStorage.setItem('user-login', payload.login)
                    localStorage.setItem('user-password', payload.password)
                } else {
                    handleHideError();
                    localStorage.setItem('jwtToken', data.jwt); // Сохраняем токен
                    localStorage.setItem('user-login', data.player.login)
                    localStorage.setItem('user-password', data.player.password)
                    localStorage.setItem('user-id', data.player.id)
                    window.location.href = "/ucp/";
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
    };

    const handleVerifyAuth = async (event) => {
        event.preventDefault(); 

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());

        try {
            const response = await fetch(api_url + "/confirm-auth", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_name: localStorage.getItem("user-login"),
                    user_password: localStorage.getItem("user-password"),
                    ip: payload.ip,
                    client: payload.client,
                    platform: payload.platform,
                    verification_code: payload.verification_code
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();

                if (data.status == "error") {
                    handleShowError();
                    setVerifyAuthErr(data.message)
                } else {
                    handleHideError();
                    localStorage.setItem('jwtToken', data.jwt); // Сохраняем токен
                    localStorage.setItem('user-login', data.player.login)
                    localStorage.setItem('user-password', data.player.password)
                    localStorage.setItem('user-id', data.player.id)
                    window.location.href = "/ucp/";
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }
    };






    const [userInfo, setUserInfo] = useState({
        browser: "",
        platform: "",
        ip: "",
    });

    useEffect(() => {
        const getPrimaryBrowser = (brands) => {
            const priorityList = ["Google Chrome", "Mozilla Firefox", "Safari", "Edge", "Opera"];
            for (const brand of priorityList) {
                if (brands.includes(brand)) {
                    return brand;
                }
            }
            return brands[0] || "Неизвестно";
        };


        const getBrowserAndPlatform = () => {
            const userAgentData = navigator.userAgentData;
            if (userAgentData) {
                const brands = userAgentData.brands.map((brand) => brand.brand);
                const browser = getPrimaryBrowser(brands);
                const platform = userAgentData.platform || "Неизвестно";
                return {browser, platform};
            }

            // Аналогично для userAgent
            return {browser: "Неизвестно", platform: "Неизвестно"};
        };

        // Получение IP
        fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => {
                const {browser, platform} = getBrowserAndPlatform();
                setUserInfo({
                    browser: browser,
                    platform: platform,
                    ip: data.ip,
                });
            })
            .catch((error) => console.error("Ошибка получения IP:", error));
    }, []);

    const loginModalContent = () => {return !gAuthNeeds ? (<div className='login-modal-content-container'>
        <span className='auth-title'>АВТОРИЗАЦИЯ</span>
        <form onSubmit={handleSubmit}>
            {showError && (
                <span className="auth-error-span">
            Неверное имя пользователя или пароль!
            </span>
            )}
            <input className='auth-input-form' placeholder='Имя аккаунта или E-mail' name="login"></input>
            <input className='auth-input-form' placeholder='Пароль' name="password" type='password'></input>
            <input type='hidden' name="ip" value={userInfo.ip}></input>
            <input type='hidden' name="client" value={userInfo.browser}></input>
            <input type='hidden' name="platform" value={userInfo.platform}></input>
            <button className='auth-input-button-login' type='submit'>ВОЙТИ</button>
        </form>
        <div className='auth-input-info-container'>
            <a href='/recovery'>Восстановить доступ<br/></a>
            <a href="/register" className='auth-input-no-account-title'>Нет аккаунта? Зарегистрироваться</a>
        </div>
    </div>) : (
    <div className='login-modal-content-container'>
    <span className='auth-title'>Подтверждение кода</span>
    <span style={{left: "0", marginLeft: "0", display: "block", position: "relative", textAlign:"left", marginTop: "20px"}}>На вашем аккаунте включена двухфакторная аутентификация. Пожалуйста, зайдите в приложение Google Authenticator и введите код для продолжения аутентификации.</span>
    <form onSubmit={handleVerifyAuth}>
        {showError && (
            <span className="auth-error-span">
                {verifyAuthErr}
            </span>
        )}
        <input className='auth-input-form' placeholder='Код аутентификации' name="verification_code" required minLength={6} maxLength={6}></input>
        <input type='hidden' name="ip" value={userInfo.ip}></input>
        <input type='hidden' name="client" value={userInfo.browser}></input>
        <input type='hidden' name="platform" value={userInfo.platform}></input>
        <button className='auth-input-button-login' type='submit' style={{marginBottom: "40px"}}>ВОЙТИ</button>
    </form>
</div>)}
        
    const [visible, setVisible] = useState(true);
    switch (index) {
        case 1:

            return (
                <div className="App">
                    <div className="main-container" style={{height: "calc(100vh + 16vh)"}}>
                        <div className='header'>
                            <button className='burger-button' onClick={triggerBurgerModal}>
                                <div></div>
                            </button>
                            <BurgerModal onTrigger={(openBurgerModal) => {
                                openBurgerModalRef.current = openBurgerModal;
                            }}/>
                            <button className='user-cabinet-button' onClick={openLoginModal}>ЛИЧНЫЙ КАБИНЕТ</button>
                            <Modal isOpen={modalIsOpen} onRequestClose={closeLoginModal} style={{
                                overlay: {
                                    position: 'fixed',
                                    zIndex: 1020,
                                    top: 0,
                                    left: 0,
                                    width: '100vw',
                                    height: '100vh',
                                    background: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                },
                                content: {
                                    width: '50vw',
                                    height: 'fit-content',
                                    border: '1px solid white',
                                    borderRadius: '30px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    backdropFilter: 'blur(15px)',
                                    overflowY: 'auto',
                                    position: 'relative',
                                    left: 'auto',
                                    color: '#FFF',
                                    margin: "0",
                                    padding: "0",
                                    transition: "0.2s",
                                }
                            }} ariaHideApp={false}>
                                {loginModalContent()}
                            </Modal>
                            <a href='/'>
                                <button className='user-button'></button>
                            </a>
                        </div>
                        {visible && <div>
                            <div className='title-container'>
                                <span className='main-title' style={{color: "rgba(240, 173, 0, 1)"}}>MEDIEVAL</span>
                                <span className='main-title'>ROLEPLAY</span>
                                <span className='desc-title'>Уникальный текстовый ролевой проект в сеттинге Средневекового фентези.</span>
                                <div className='buttons-container'>
                                    <a href="/register">
                                        <button className='button-signUp'>ЗАРЕГИСТРИРОВАТЬСЯ</button>
                                    </a>
                                    <a href="/med_setup.exe" download={true}>
                                    <button className='button-downloadLauncher'>СКАЧАТЬ ЛАУНЧЕР</button>
                                    </a>
                                </div>
                                <div className='social-icons-container'>
                                    <a href="https://vk.com/medievalrpnet" target='_blank'>
                                        <button className='vk-icon'></button>
                                    </a>
                                    <a href="https://t.me/medieval_rp" target='_blank'>
                                        <button className='telegram-icon'></button>
                                    </a>
                                </div>

                            </div>
                            <div className='footer'>
                                <a href='/privacy_policy.pdf' target='_blank'><p>Политика конфиденциальности</p></a>
                                <p>© 2026. Medieval Role Play. Все права защищены.</p>
                                <p>Пользовательское соглашение</p>
                            </div>
                        </div>}

                    </div>
                </div>

            );
        case 2:
            return (
                <h1>huita</h1>
            )
        case 3:
            return (
                <center><h1>Ошибка 404: страница не найдена.</h1></center>
            )
        case 4:


    }

};


const RecoveryRender = () => {

    const openBurgerModalRef = useRef(null);
    const [targetTimer, setTargetTimer] = useState(60)
    const api_reg_url_submit_code = api + "users/submit-recovery"
    const api_recovery_pass = api + "users/recovery-pass"
    const triggerBurgerModal = () => {
        if (openBurgerModalRef.current) {
            openBurgerModalRef.current();
        }
    };
    const [stage, setStage] = useState(1)

    const handleRecoverySubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        try {
            const response = await fetch(api_recovery_pass, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if (data === true) {
                    localStorage.setItem("user-email", payload.email)
                    setStage(2)
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }

    }

    const SubmitCode = async (event) => {

        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        try {
            const response = await fetch(api_reg_url_submit_code, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: payload["pincode-1"] + payload["pincode-2"] + payload["pincode-3"] + payload["pincode-4"] + payload["pincode-5"] + payload["pincode-6"],
                    email: localStorage.getItem("user-email")
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
            }
            if (response.ok) {
                if (response.headers.get('Content-Length') === '0') {
                    throw new Error('Empty response body');
                }
                const data = await response.json();
                if (data === true) {
                    alert('Письмо с дальнейшими инструкциями было выслано на ваш e-mail.');
                    localStorage.clear()
                    setTimeout(() => {
                        window.location.href = "../../../";
                    }, 3000);
                }

            } else {
                const error = await response.json();
                console.error('Ошибка:', error);

            }
        } catch (err) {
            console.error('Ошибка соединения:', err);
        }

    }

    switch (stage) {
        case 1:
            return (
                <div className="App">
                    <div className="main-container">
                        <div className='header'>
                            <button className='burger-button' onClick={triggerBurgerModal}>
                                <div></div>
                            </button>
                            <BurgerModal onTrigger={(openBurgerModal) => {
                                openBurgerModalRef.current = openBurgerModal;
                            }}/>
                        </div>
                        <div className='register-question-container'
                             style={{minHeight: "350px", top: "10%", bottom: "auto"}}>
                            <div className='register-container'>

                                <span className='register-title'>ВОССТАНОВЛЕНИЕ ПАРОЛЯ</span>
                                <form onSubmit={handleRecoverySubmit}>
                                    <div>
                                        <input className='register-input-form' placeholder='Имя аккаунта*' type='text'
                                               name="login" maxLength={20} minLength={3}></input>
                                        <input className='register-input-form' placeholder='Email*' type='email'
                                               name="email" maxLength={36} minLength={6}></input>
                                    </div>
                                    <button className='register-button-next' type="submit">ВОССТАНОВИТЬ ПАРОЛЬ</button>
                                </form>

                            </div>

                        </div>
                    </div>
                </div>
            )
            break
        case 2:

            const api_reg_url_send_mail = api + "users/recovery-pass"
            const handleInputChange = (e, index) => {
                const value = e.target.value;
                if (/^\d$/.test(value)) {
                    const nextInput = document.getElementById(`pincode-${index + 1}`);
                    if (nextInput) nextInput.focus();
                } else {
                    e.target.value = "";
                }
            };

            const handleKeyDown = (e, index) => {
                if (e.key === "Backspace" && e.target.value === "") {
                    const prevInput = document.getElementById(`pincode-${index - 1}`);
                    if (prevInput) prevInput.focus();
                }
            };

            const timer = setTimeout(() => {
                if (targetTimer != 0) {
                    setTargetTimer(targetTimer - 1)
                }
            }, 1000); // 3 секунды

            const handleResendMail = async () => {
                if (targetTimer > 0 || localStorage.getItem("user-email") === undefined || localStorage.getItem("user-email") === null) {
                    return;
                }
                try {
                    const response = await fetch(api_reg_url_send_mail, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({email: localStorage.getItem("user-email")}),
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
                    }
                    if (response.ok) {
                        if (response.headers.get('Content-Length') === '0') {
                            throw new Error('Empty response body');
                        }
                        const data = await response.json();
                        if (data === true) {
                            setTargetTimer(60)
                        } else {
                            alert("Произошла непредвиденная ошибка. Попробуйте позже!")
                        }


                    } else {
                        const error = await response.json();
                        console.error('Ошибка:', error);

                    }
                } catch (err) {
                    console.error('Ошибка соединения:', err);
                }
            }
            return (
                <div className="App">
                    <div className="main-container">
                        <div className='header'>
                            <button className='burger-button' onClick={triggerBurgerModal}>
                                <div></div>
                            </button>
                            <BurgerModal onTrigger={(openBurgerModal) => {
                                openBurgerModalRef.current = openBurgerModal;
                            }}/>
                        </div>
                        <div className='register-question-container'>
                            <div className='register-container'>

                                <span className='register-title'>ВОССТАНОВЛЕНИЕ ПАРОЛЯ</span>
                                <span>На электронную почту вам было выслано письмо подтверждения. Пожалуйста, введите код из письма в поля ниже.</span>
                                <form onSubmit={SubmitCode}>
                                    <center>
                                        <div>
                                            {[...Array(6)].map((_, i) => (
                                                <input
                                                    key={i}
                                                    id={`pincode-${i + 1}`}
                                                    className="code-input-number"
                                                    maxLength={1}
                                                    pattern="[\d]*"
                                                    type="tel"
                                                    name={`pincode-${i + 1}`}
                                                    onChange={(e) => handleInputChange(e, i + 1)}
                                                    onKeyDown={(e) => handleKeyDown(e, i + 1)}
                                                />
                                            ))}
                                        </div>
                                    </center>
                                    <span
                                        className='reg-span-timer'>{targetTimer > 0 ? "Вы сможете переотправить письмо через " + targetTimer + " секунд" : "Вы можете переотправить письмо."}</span>
                                    <button type='button' className='ucp-simple-blur-button' style={{
                                        width: "97%",
                                        borderRadius: "15px",
                                        height: "45px",
                                        marginBottom: "0",
                                        fontSize: "16px"
                                    }} onClick={handleResendMail}>ПЕРЕОТПРАВИТЬ ПИСЬМО
                                    </button>
                                    <button className='register-button-next' type="submit"
                                            style={{marginTop: "20px"}}>ПОДТВЕРДИТЬ
                                    </button>
                                </form>

                            </div>

                        </div>
                    </div>
                </div>
            )
            break;
    }
}


export const GuestPage = () => BuildPage(1);
export const PageTwo = () => BuildPage(2);
export const PageNotFound = () => BuildPage(3);
export const RegisterPage = () => Register();
export const Recovery = () => RecoveryRender()